import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Stats } from "@/components/landing/Stats";
import { Features } from "@/components/landing/Features";
import { Steps } from "@/components/landing/Steps";
import { Preview } from "@/components/landing/Preview";
import { ScanFridge } from "@/components/landing/ScanFridge";
import { Testimonials } from "@/components/landing/Testimonials";
import { WhyJosfit } from "@/components/landing/WhyJosfit";
import { ByokTutorial } from "@/components/landing/ByokTutorial";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { Download, Footer } from "@/components/landing/Download";
import { AnnouncementBanner } from "@/components/landing/AnnouncementBanner";
import { AppLaunchProvider } from "@/components/landing/AppLaunch";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  return (
    <AppLaunchProvider>
      <AnnouncementBanner />
      <div
        className="min-h-screen bg-[#070A12] font-dm-sans"
        style={{ paddingTop: "var(--banner-h, 0px)" }}
      >
        <Navbar />
        <main>
          <Hero />
          <Stats />
          <Features />
          <Steps />
          <Preview />
          <ScanFridge />
          <Testimonials />
          <ByokTutorial />
          <WhyJosfit />
          <Pricing />
          <FAQ />
          <Download />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </AppLaunchProvider>
  );
}
